import React, { useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import ImageComponent from "../ImageComponent";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import { updateUserProfile } from "../../services/authAPI";
import { toast } from "react-toastify";
import { handleApiError } from "../../services/errorHandler";
import Avatar from "../choose-avatar-components/Avatar";

const BlockAndReportComponent = ({
  user,
  selectedUser,
  toggleMenu,
  accessToken,
  userProfileData,
  blockedUsers,
  refetchProfile,
  setFilteredSuggestions,
  setSearchText,
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const callUpdateEventAPI = async (updates) => {
    setIsUpdating(true);
    const bodyParams = {
      accessToken: accessToken,
      username: userProfileData.userID,
      ...updates,
    };

    try {
      const response = await updateUserProfile(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          toast.success("User blocked successfully");
          setSearchText("");
          setFilteredSuggestions([]);
          await refetchProfile();
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleBlockUser = (userID) => {
    if (blockedUsers.includes(userID)) {
      toast.info("User is already blocked");
      return;
    }
    // Add the new user to the existing list of blocked users
    const updatedBlockedUsers = [...blockedUsers, userID];

    // Call the API with the updated list
    callUpdateEventAPI({ blockedUsers: updatedBlockedUsers });
  };
  return (
    <View
      key={user.id}
      style={{
        width: 60,
        position: "relative",
        zIndex: selectedUser === user ? 999 : 1,
      }}
    >
      <TouchableOpacity
        style={[{ alignItems: "center", position: "relative" }]}
        onPress={() => toggleMenu(user)}
      >
        {/* <ImageComponent
          url={
            user?.profilePicture
              ? user?.profilePicture
              : AppImages.icProfilePlaceHolder
          }
          style={[
            {
              resizeMode: "contain",
              width: 49,
              height: 49,
              borderRadius: 50,
              zIndex: selectedUser === user ? 999 : 1,
              position: "relative",
            },
            selectedUser === user && {
              borderColor: "red",
              borderWidth: 2,
            },
          ]}
        /> */}
        <View
          style={[
            {
              zIndex: selectedUser === user ? 999 : 1,
              position: "relative",
            },
            selectedUser === user && {
              borderColor: "red",
              borderWidth: 2,
              borderRadius: 50,
            },
          ]}
        >
          <Avatar
            src={
              user?.profilePicture
                ? user?.profilePicture
                : AppImages.icProfilePlaceHolder
            }
            variant="blockUser"
          />
        </View>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            {
              color: AppColors.gray_C3C3C3,
              marginTop: 5,
              width: 60,
              textAlign: "center",
              zIndex: selectedUser === user ? 999 : 1,
              position: "relative",
            },
          ]}
        >
          {user.userID}
        </Text>
      </TouchableOpacity>
      {selectedUser === user && (
        <View
          style={{
            position: "absolute",
            top: 60,
            left: -11,
            zIndex: 999,
            elevation: 999,
            marginTop: 10,
            backgroundColor: AppColors.black,
            borderWidth: 2,
            borderColor: AppColors.white,
          }}
        >
          <TouchableOpacity onPress={() => handleBlockUser(user.userID)}>
            <View
              style={{
                flexDirection: "row",
                gap: 2,
                padding: 10,
                borderBottomColor: AppColors.white,
                borderBottomWidth: 2,
              }}
            >
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    {
                      color: AppColors.red_FA0A0A,
                    },
                  ]}
                >
                  Block
                </Text>
              </View>
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    {
                      color: AppColors.red_FA0A0A,
                    },
                  ]}
                >
                  {user.userID}
                </Text>
              </View>
            </View>
          </TouchableOpacity>
          <TouchableOpacity>
            <View
              style={{
                flexDirection: "row",
                gap: 2,
                padding: 10,
              }}
            >
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    {
                      color: AppColors.red_FA0A0A,
                    },
                  ]}
                >
                  Report
                </Text>
              </View>
              <View>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_10,
                    {
                      color: AppColors.red_FA0A0A,
                    },
                  ]}
                >
                  {user.userID}
                </Text>
              </View>
            </View>
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default BlockAndReportComponent;
